import { frontendURL } from '../../../helper/URLHelper';
import EquipeOnline from './EquipeOnline.vue';
import EquipeOnlineHistory from './EquipeOnlineHistory.vue';
import Carteirizacao from './Carteirizacao.vue';

// Aceleres: painel "Equipe Online" (presenca real dos vendedores).
// Restrito a gestor (administrator) via meta.permissions.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/carteirizacao'),
    name: 'aceleres_carteirizacao',
    meta: {
      permissions: ['administrator'],
    },
    component: Carteirizacao,
  },
  {
    path: frontendURL('accounts/:accountId/equipe-online'),
    name: 'aceleres_team_presence',
    meta: {
      permissions: ['administrator'],
    },
    component: EquipeOnline,
  },
  {
    path: frontendURL('accounts/:accountId/equipe-online/historico'),
    name: 'aceleres_team_presence_history',
    meta: {
      permissions: ['administrator'],
    },
    component: EquipeOnlineHistory,
  },
];
